import * as React from 'react';

export type TaWelcomePageModalProps = {
	onModalClick: (val: boolean) => void;
	returningUserText: string[];
};

export const TaWelcomePageModal = ({
	onModalClick,
	returningUserText,
}: TaWelcomePageModalProps) => {
	const handleModalClick = (val: boolean) => {
		onModalClick(val);
	};

	return (
		<div className='ta-welcome-modal'>
			<div className='ta-welcome-modal_text'>
				<div className='ta-welcome-modal_greet'>
					{returningUserText[0]}
				</div>
				<div className='ta-welcome-modal_description'>
					{returningUserText[1]}
				</div>
			</div>
			<div className='ta-welcome-modal_buttons'>
				<button
					className='ta-welcome-modal_button'
					onClick={() => handleModalClick(true)}
				>
					Continue
				</button>
				<button
					className='ta-welcome-modal_button'
					onClick={() => handleModalClick(false)}
				>
					Start over
				</button>
			</div>
		</div>
	);
};
